<div class="top-group custom-button-toggle">
  <div class="toggle-button-container">
    <mat-button-toggle-group [value]="toggleViewMode" (change)="onChange($event)">
      <mat-button-toggle [value]="sourceMode">{{
        T_SCOPE + '.source-selector' | translate
      }}</mat-button-toggle>
      <mat-button-toggle [value]="settingsMode">{{
        T_SCOPE + '.settings-selector' | translate
      }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

<div [hidden]="toggleViewMode !== sourceMode" class="detail-panel-source">
  <ct-create-dashboard-widget-form
    [initialCartSelection]="cartAndSettings"
    [disableAddToDashboard]="true"
    [isSettingsComponent]="true"
    (isValidCart)="onValidSourceChange($event)"
  ></ct-create-dashboard-widget-form>
</div>
<div [hidden]="toggleViewMode !== settingsMode" class="detail-panel-settings">
  <ng-template injectContentHost></ng-template>
</div>
